import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const EllipseShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 407 244.6",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M58.1 207.6c38.7 23.8 90.3 37 145.4 37s106.6-13.1 145.4-37c37.5-23.1 58.1-53.4 58.1-85.3S386.3 60.1 348.8 37C310.1 13.1 258.5 0 203.5 0S96.8 13.1 58.1 37C20.6 60.1 0 90.4 0 122.3s20.6 62.2 58.1 85.3z"
    })
  });
};

export { EllipseShape };
//# sourceMappingURL=EllipseShape.js.map
